import React from 'react';
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import {IonApp, IonTabs, IonRouterOutlet, IonTabBar, IonTabButton, IonIcon, IonLabel} from '@ionic/react';
import {IonReactRouter} from '@ionic/react-router';
import { Route, Redirect } from 'react-router';
import {informationCircleOutline, trophyOutline,imagesOutline,  settingsOutline, personAddOutline} from 'ionicons/icons'
import About from './Pages/About/About';
import Achievements from './Pages/Achievements/Achievements';
import Gallery from './Pages/Gallery/Gallery';
import JoinUs from './Pages/JoinUs/JoinUs';
import Enrollment from './Pages/EnrollmentData/Enrollment';

import './Themes/Themes.css'
import Settings from './Pages/Settings/Settings';
import NotFound from './Pages/NotFound/NotFound';

const App :React.FC = () =>{
    return (
        <IonApp>
            <IonReactRouter>
                <IonTabs>
                    <IonRouterOutlet>
                        <Route path="/about" component={About} exact={true} />
                        <Route path="/achievements" component={Achievements} exact={true} />
                        <Route path="/pics" component={Gallery} exact={true} />
                        <Route path="/joinus" component={JoinUs} exact={true} />
                        <Route path="/joinus/enrollment" component={Enrollment} exact={true} />
                        <Route path="/settings" component={Settings} exact={true} />
                        <Route path="/" render={() => <Redirect to="/about" />} exact={true} />
                        <Route component={NotFound} />
                    </IonRouterOutlet>
                    <IonTabBar mode="ios" slot="bottom">
                        <IonTabButton mode="ios" tab="tab1" href="/about">
                            <IonIcon mode="ios" icon={informationCircleOutline} />
                            <IonLabel mode="ios">About</IonLabel>
                        </IonTabButton>
                        <IonTabButton mode="ios" tab="tab2" href="/achievements">
                            <IonIcon mode="ios" icon={trophyOutline}/>
                            <IonLabel mode="ios">Achievements</IonLabel>
                        </IonTabButton>
                        <IonTabButton mode="ios" tab="tab3" href="/pics">
                            <IonIcon mode="ios" icon={imagesOutline}/>
                            <IonLabel mode="ios">Gallery</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="tab4" mode="ios" href="/joinus">
                            <IonIcon mode="ios" icon={personAddOutline} />
                            <IonLabel mode="ios">Join Us</IonLabel>
                        </IonTabButton>
                        <IonTabButton mode="ios" tab="tab5" href="/settings">
                            <IonIcon mode="ios" icon={settingsOutline} />
                            <IonLabel mode="ios">Settings</IonLabel>
                        </IonTabButton>
                    </IonTabBar>
                </IonTabs>
            </IonReactRouter>
        </IonApp>
    );
}

export default App;
